import { z } from "zod";
import { AppointmentTimeZone } from "@/api/enums/appointment.enums";
import type { Endpoint } from "./types";

// ── Zod Schemas ─────────────────────────────────────────────────────

export const timeSlotSchema = z.object({
  id: z.string(),
  specialistId: z.string(),
  specialistName: z.string(),
  locationId: z.string().nullable(),
  dateTime: z.string(),
  timeZone: z.preprocess(
    (value) => value || AppointmentTimeZone.EST,
    z.enum(AppointmentTimeZone),
  ),
});

export const availableTimeSlotsListResponseSchema = z.object({
  availableTimeSlots: z.array(timeSlotSchema),
  total: z.number(),
  take: z.number(),
  skip: z.number(),
  hasMore: z.boolean(),
  searchCriteria: z.object({
    slug: z.string().optional(),
    locationId: z.string().optional(),
  }),
});

// ── Inferred Types ──────────────────────────────────────────────────

export type AvailableTimeSlotsRequest = {
  slug: string;
  locationId?: string | null;
  take?: number;
  skip?: number;
};

export type TimeSlotDto = z.infer<typeof timeSlotSchema>;
export type AvailableTimeSlotsDto = TimeSlotDto;
export type AvailableTimeSlotsListResponse = z.infer<
  typeof availableTimeSlotsListResponseSchema
>;

// ── Endpoints ──────────────────────────────────────────────────────

export const appointmentSlotEndpoints = {
  available: {
    method: "GET",
    path: "/appointment-slots/available-time-slots",
    auth: false,
  } as Endpoint,
} as const;
